import React from 'react';
import { useEffect, useState } from 'react'

import { useSelector, useDispatch } from 'react-redux'
//import './assets/css/emails.css'

//import './assets/css/systemManagement.css'
import '../assets/css/systemManagement.css'
import { RenewalsModel } from '../models/RenewalsModel'

import { RenewalsConfigData, Credential, CredentialShlomo } from '../models/superbit-api-models';



const RenewalsManagement = () => {

    const [renewalsConfigDatas, setRenewalsConfigDatas] = useState<RenewalsConfigData | undefined>(undefined);
    const [ayalonUser, setAyalonUser] = useState<string | undefined>(undefined);
    const [ayalonPass, setAyalonPass] = useState<string | undefined>(undefined);

    const [hachsharaUser, setHachsharaUser] = useState<string | undefined>(undefined);
    const [hachsharaPass, setHachsharaPass] = useState<string | undefined>(undefined);

    const [fnxUser, setFnxUser] = useState<string | undefined>(undefined);
    const [fnxPass, setFnxPass] = useState<string | undefined>(undefined);

    const [clalUser, setClalUser] = useState<string | undefined>(undefined);
    const [clalPass, setClalPass] = useState<string | undefined>(undefined);

    const [migdalUser, setMigdalUser] = useState<string | undefined>(undefined);
    const [migdalPass, setMigdalPass] = useState<string | undefined>(undefined);

    const [menoraUser, setMenoraUser] = useState<string | undefined>(undefined);
    const [menoraPass, setMenoraPass] = useState<string | undefined>(undefined);

    const [shomeraUser, setShomeraUser] = useState<string | undefined>(undefined);
    const [shomeraPass, setShomeraPass] = useState<string | undefined>(undefined);

    const [shlomoUser, setShlomoUser] = useState<string | undefined>(undefined);
    const [shlomoPass, setShlomoPass] = useState<string | undefined>(undefined);
    const [shlomoIdentity, setShlomoIdentity] = useState<string | undefined>(undefined);

    const [harelUser, setHarelUser] = useState<string | undefined>(undefined);
    const [harelPass, setHarelPass] = useState<string | undefined>(undefined);

    useEffect(() => {
        init();

    }, [])



    const init = async () => {
        let data = await new RenewalsModel().renewalGetSettings();
        
        setRenewalsConfigDatas(data);
        setAyalonUser(data.Ayalon.username);
        setAyalonPass(data.Ayalon.password);

        setHachsharaUser(data.Hachshara.username);
        setHachsharaPass(data.Hachshara.password);

        setFnxUser(data.Fnx.username);
        setFnxPass(data.Fnx.password);

        setClalUser(data.Clal.username);
        setClalPass(data.Clal.password);

        setMigdalUser(data.Migdal.username);
        setMigdalPass(data.Migdal.password);

        setMenoraUser(data.Menora.username);
        setMenoraPass(data.Menora.password);

        setShomeraUser(data.Shomera.username);
        setShomeraPass(data.Shomera.password);

        setShlomoUser(data.Shlomo.username);
        setShlomoPass(data.Shlomo.password);
        setShlomoIdentity(data.Shlomo.identity);

        setHarelUser(data.Harel.username);
        setHarelPass(data.Harel.password);

    };
    const onSave = async () => {
        const config = new RenewalsConfigData();
        if (config) {

            config.Ayalon = Credential.fromJS({ username: ayalonUser, password: ayalonPass });
            config.Hachshara = Credential.fromJS({ username: hachsharaUser, password: hachsharaPass });
            config.Fnx = Credential.fromJS({ username: fnxUser, password: fnxPass });
            config.Clal = Credential.fromJS({ username: clalUser, password: clalPass });
            config.Migdal = Credential.fromJS({ username: migdalUser, password: migdalPass });
            config.Menora = Credential.fromJS({ username: menoraUser, password: menoraPass });
            config.Shomera = Credential.fromJS({ username: shomeraUser, password: shomeraPass });
            config.Shlomo = CredentialShlomo.fromJS({ username: shlomoUser, password: shlomoPass ,identity:shlomoIdentity});
            config.Harel = Credential.fromJS({ username: harelUser, password: harelPass });
            await new RenewalsModel().renewalUpdateSettings(config);
        }


    }



        const setUserName = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
            const txt = event.currentTarget.value.trim();

        };



        const setPassword = async (event: any, name: string) => {
            const txt = event.currentTarget.value.trim();
            
            switch (name) {
                case "Ayalon": setAyalonPass(txt); break;
                case "Hachshara": setHachsharaPass(txt); break;
                case "Fnx": setFnxPass(txt); break;
                case "Clal": setClalPass(txt); break;
                case "Migdal": setMigdalPass(txt); break;
                case "Menora": setMenoraPass(txt); break;
                case "Shomera": setShomeraPass(txt); break;
                case "Shlomo": setShlomoPass(txt); break;
                case "Harel": setHarelPass(txt); break;

            }

        }
        const setshlomoIdentityF = async (event: any)=>{
           const txt = event.currentTarget.value.trim();
            setShlomoIdentity(txt); 
        }

        const setUser = async (event: any, name: string) => {
            const txt = event.currentTarget.value.trim();
            
            switch (name) {
                case "Ayalon": setAyalonUser(txt); break;
                case "Hachshara": setHachsharaUser(txt); break;
                case "Fnx": setFnxUser(txt); break;
                case "Clal": setClalUser(txt); break;
                case "Migdal": setMigdalUser(txt); break;
                case "Menora": setMenoraUser(txt); break;
                case "Shomera": setShomeraUser(txt); break;
                case "Shlomo": setShlomoUser(txt); break;
                case "Harel": setHarelUser(txt); break;

            }

        }



        // documents end

        return (
            <div className='main-content rtl content-body leads-list'>
                <div >
                    <div className='data-card '>
                        <div className='data-card-body flex-space-between'>
                            <div>איילון</div>
                            <div><input type="text"
                                onBlur={(e: any) => setUser(e, "Ayalon")}
                                value={ayalonUser}
                                onChange={(e: any) => setUser(e, "Ayalon")}
                            /> </div>
                            <div><input type="text"
                                onBlur={(e: any) => setPassword(e, "Ayalon")}
                                value={ayalonPass}
                                onChange={(e: any) => setPassword(e, "Ayalon")}
                            /> </div>
                        </div>
                    </div>

                    <div className='data-card '>
                        <div className='data-card-body flex-space-between'>
                            <div>הכשרה</div>
                            <div><input type="text"
                                onBlur={(e: any) => setUser(e, "Hachshara")}
                                value={hachsharaUser}
                                onChange={(e: any) => setUser(e, "Hachshara")}
                            /> </div>
                            <div><input type="text"
                                onBlur={(e: any) => setPassword(e, "Hachshara")}
                                value={hachsharaPass}
                                onChange={(e: any) => setPassword(e, "Hachshara")}
                            /> </div>
                        </div>
                    </div>
                    <div className='data-card '>
                        <div className='data-card-body flex-space-between'>
                            <div>הפניקס</div>
                            <div><input type="text"
                                onBlur={(e: any) => setUser(e, "Fnx")}
                                value={fnxUser}
                                onChange={(e: any) => setUser(e, "Fnx")}
                            /> </div>
                            <div><input type="text"
                                onBlur={(e: any) => setPassword(e, "Fnx")}
                                value={fnxPass}
                                onChange={(e: any) => setPassword(e, "Fnx")}
                            /> </div>
                        </div>
                    </div>
                    <div className='data-card '>
                        <div className='data-card-body flex-space-between'>
                            <div>כלל</div>
                            <div><input type="text"
                                onBlur={(e: any) => setUser(e, "Clal")}
                                value={clalUser}
                                onChange={(e: any) => setUser(e, "Clal")}
                            /> </div>
                            <div><input type="text"
                                onBlur={(e: any) => setPassword(e, "Clal")}
                                value={clalPass}
                                onChange={(e: any) => setPassword(e, "Clal")}
                            /> </div>
                        </div>
                    </div>
                    <div className='data-card '>
                        <div className='data-card-body flex-space-between'>
                            <div>מגדל</div>
                            <div><input type="text"
                                onBlur={(e: any) => setUser(e, "Migdal")}
                                value={migdalUser}
                                onChange={(e: any) => setUser(e, "Migdal")}
                            /> </div>
                            <div><input type="text"
                                onBlur={(e: any) => setPassword(e, "Migdal")}
                                value={migdalPass}
                                onChange={(e: any) => setPassword(e, "Migdal")}
                            /> </div>
                        </div>
                    </div>
                    <div className='data-card '>
                        <div className='data-card-body flex-space-between'>
                            <div>מנורה</div>
                            <div><input type="text"
                                onBlur={(e: any) => setUser(e, "Menora")}
                                value={menoraUser}
                                onChange={(e: any) => setUser(e, "Menora")}
                            /> </div>
                            <div><input type="text"
                                onBlur={(e: any) => setPassword(e, "Menora")}
                                value={menoraPass}
                                onChange={(e: any) => setPassword(e, "Menora")}
                            /> </div>
                        </div>
                    </div>
                    <div className='data-card '>
                        <div className='data-card-body flex-space-between'>
                            <div>שומרה</div>
                            <div><input type="text"
                                onBlur={(e: any) => setUser(e, "Shomera")}
                                value={shomeraUser}
                                onChange={(e: any) => setUser(e, "Shomera")}
                            /> </div>
                            <div><input type="text"
                                onBlur={(e: any) => setPassword(e, "Shomera")}
                                value={shomeraPass}
                                onChange={(e: any) => setPassword(e, "Shomera")}
                            /> </div>
                        </div>
                    </div>
                    <div className='data-card '>
                        <div className='data-card-body flex-space-between'>
                            <div>שלמה</div>
                            <div><input type="text"
                                onBlur={(e: any) => setUser(e, "Shlomo")}
                                value={shlomoUser}
                                onChange={(e: any) => setUser(e, "Shlomo")}
                            /> </div>
                            <div><input type="text"
                                onBlur={(e: any) => setPassword(e, "Shlomo")}
                                value={shlomoPass}
                                onChange={(e: any) => setPassword(e, "Shlomo")}
                            /> </div>
                            <div><input type="text"
                                onBlur={(e: any) => setshlomoIdentityF(e)}
                                value={shlomoIdentity}
                                onChange={(e: any) => setshlomoIdentityF(e)}
                            /> </div>
                        </div>
                    </div>
                    <div className='data-card '>
                        <div className='data-card-body flex-space-between'>
                            <div>הראל</div>
                            <div><input type="text"
                                onBlur={(e: any) => setUser(e, "Harel")}
                                value={harelUser}
                                onChange={(e: any) => setUser(e, "Harel")}
                            /> </div>
                            <div><input type="text"
                                onBlur={(e: any) => setPassword(e, "Harel")}
                                value={harelPass}
                                onChange={(e: any) => setPassword(e, "Harel")}
                            /> </div>
                        </div>
                    </div>
                </div>

                <div>
                    <button className="button blue pointer" onClick={(e: any) => onSave()}>
                        שמור
                    </button>
                </div>
            </div>











        )
    }

    export default RenewalsManagement;
    export { };
